module.exports = __webpack_public_path__ + "static/media/3.a91eb071.png";